export const SET_BRIDGE_LIST = 'SET_BRIDGE_LIST'
export const SET_IS_ADMIN = 'SET_IS_ADMIN'
